import AppCopy from "copy/AppCopy";
import { CarCardProps } from "declarations/card";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCar } from "reducers/carReducer";
import { Paths } from "router/Paths";
import { CarStatusType } from "types/loadedData";
import { translateDashboardText } from "i18n/dashboardLanguage";

function LiveCarCard({ car }: CarCardProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    detailsText,
    carNoText,
    assignedText,
    CustomerText,
    statusText,
    unassignedText,
  } = AppCopy.overview;
  const status = car.status;

  const statusTagColor = (carStatus: CarStatusType): string => {
    switch (carStatus) {
      case "Assigned":
        return Classname.statusTagAssigned;
      case "Cancelled":
        return Classname.statusTagCancelled;
      case "Rented":
        return Classname.statusTagRented;
      case "Sold":
        return Classname.statusTagSold;
      default:
        return "";
    }
  };

  const statusBorderColor = (carStatus: CarStatusType): string => {
    switch (carStatus) {
      case "Assigned":
        return Classname.statusContainerAssigned;
      case "Cancelled":
        return Classname.statusContainerCancelled;
      case "Rented":
        return Classname.statusContainerRented;
      case "Sold":
        return Classname.statusContainerSold;
      default:
        return "";
    }
  };

  const handleDetails = () => {
    dispatch(setCar(car));
    navigate(`${Paths.cars}/${car._id}`);
  };

  const handleOnClickStaff = () => {
    if (!car.assigned?._id) return;
    navigate(`${Paths.staff}/${car.assigned?._id}`);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.carNo}>
        <span className={Classname.title}>{carNoText}</span>
        <span className={Classname.carTag}>
          {car.tag}
          <span className={Classname.carTagBold}>
            {car.listingType === "Rent" ? "R" : "S"}
          </span>{" "}
        </span>
      </div>
      <div className={Classname.asigned} onClick={handleOnClickStaff}>
        <span className={Classname.title}>{assignedText}</span>
        <span>{car.assigned?.name || unassignedText}</span>
      </div>
      <div className={Classname.status}>
        <span className={Classname.title}>{statusText}</span>
        <div className={Classname.statusContent}>
          <div
            className={`${Classname.statusTagContainer} ${statusBorderColor(
              status
            )}`}
          >
            <div
              className={`${Classname.statusTag} ${statusTagColor(status)}`}
            ></div>
          </div>
          <span>{translateDashboardText(status)}</span>
        </div>
      </div>
      <div className={Classname.customer}>
        <span className={Classname.title}>{CustomerText}</span>
        <span>{car.buyerName || "—"}</span>
      </div>
      <div className={Classname.detail}>
        <button onClick={handleDetails} className={Classname.detailsButton}>
          {detailsText}
        </button>
      </div>
    </div>
  );
}

export default LiveCarCard;

const Classname = {
  container:
    "flex w-full flex-wrap items-center justify-between border-b border-slate-100 px-2 py-3 text-sm text-secondaryText hover:bg-slate-50 sm:min-h-14 sm:flex-nowrap",
  carNo: "w-32 sm:w-1/6",
  asigned: "w-32 sm:w-1/6 text-blue my-2 sm:my-0 cursor-pointer",
  status: "w-32 sm:w-1/6 flex flex-col my-2 sm:my-0 ",
  customer: "w-32 sm:w-1/6 flex flex-col sm:justify-end my-2 sm:my-0 ",
  detail: "w-32 sm:w-1/6 flex sm:justify-end my-2 sm:my-0 ",

  title: "flex sm:hidden my-2 text-xs text-secondaryText",

  carTag:
    "flex items-center justify-center w-20 bg-bgSecondary rounded-md text-primaryText",
  carTagBold: "font-bold",
  statusTagContainer:
    "w-4 h-4 rounded-full flex items-center justify-center border",
  statusTag: "w-3 h-3 rounded-full",
  statusContent: "flex items-center gap-4",

  statusContainerAssigned: "border-statusAssigned",
  statusContainerCancelled: "border-statusCancelled",
  statusContainerRented: "border-statusRented",
  statusContainerSold: "border-statusSold",

  statusTagAssigned: "bg-statusAssigned",
  statusTagCancelled: "bg-statusCancelled",
  statusTagRented: "bg-statusRented",
  statusTagSold: "bg-statusSold",

  detailsButton: "rounded-lg bg-blue px-3 py-1.5 text-xs font-semibold text-white",
};
